export { SubRecordComponent } from './sub-record.component';
